import { useMutation } from '@tanstack/vue-query';
import { getApi } from '../api';

export default () => useMutation({
  mutationFn: ({ credential, name }: { credential: Record<string, unknown>; name: string }) => {
    const { api, baseURL } = getApi();
    return api
      .post(`/api/passkeys/register`, { ...credential, friendly_name: name }, { baseURL })
      .then((res) => res.data);
  },
});
